import { Pipe, PipeTransform, Inject } from '@angular/core';

import { APP_CONFIG, AppConfig } from '../../app.models';
import { Router } from '../../devices/devices.models';

@Pipe({
    name: 'liebherrM2MGateUrl',
})
export class GetM2MGateUrlPipe implements PipeTransform {
    constructor(@Inject(APP_CONFIG) private appConfig: AppConfig) {}
    transform(device: Router) {
        return device.id ? this.checkUrlEnd(this.appConfig.m2mgate_portal_url) + '#/devices/' + device.serialNumber : undefined;
    }

    private checkUrlEnd(url: string) {
        return url?.endsWith('/') ? url : url + '/';
    }
}
